export default __webpack_public_path__ + "static/media/met1.6eeb625d.jpg";